import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import { Helmet } from 'react-helmet';

interface Props {
    description: string;
    title: string;
    lang?: string;
    meta?: { name: string; content: string }[];
    keywords?: string;
}

export const Seo: React.FC<Props> = ({ description, lang, meta, title, keywords }) => {
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        author
                    }
                }
            }
        `
    );

    const metaDescription = description || site.siteMetadata.description;
    const defaultTitle =
        (title && title.replace(/^\w/, c => c.toUpperCase())) || site.siteMetadata?.title;
    const defaultKeywords = keywords || site.siteMetadata.keywords;

    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={`${defaultTitle}`}
            meta={[
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    name: `keywords`,
                    content: defaultKeywords,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: site.siteMetadata?.author || ``,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
                {
                    name: `google-site-verification`,
                    content: `Oy_PKvmRsZlxG51gEygQS8ynu0cGb34HxW1tXyEcAeg`,
                },
            ].concat(meta)}
        >
            <script type="application/ld+json">
                {`{
                "@context": "https://schema.org",
                "@type": "Dentist",
                "name": "Kidz Dental Care",
                "image": "https://c3-preview.prosites.com/281207/ed/PageMeetTheTeam/6f1e528c-b656-422e-abad-1e9adc8449fb_lg.jpg",
                "@id": "https://www.kidzdentalcare661.com/",
                "url": "https://www.kidzdentalcare661.com/",
                "telephone": "(661) 388-0499",
                "email": "office@kidzdentalcare661.com",
                "priceRange": "$$",
                "alumni": "UCLA",
                "knowsLanguage": ["english", "spanish", "Hindi"],
                "paymentAccepted": [ "cash", "check", "credit card", "insurance", "financing", "debit", "visa", "Discover", "American Express" ],
                "memberOf": {
                "@type": "Organization",
                "name": ["American Dental Association", "California Dental Association", "American Academy of Pediatric Dentistry", "California Society of Pediatric Dentistry"]
                },
                "hasMap": "https://g.page/KDC-SCV?share",
                    "medicalSpecialty": ["Pediatric Dentistry", "Dental Cleanings", "Sedation Dentistry"],
                "areaServed": ["Santa Clarita", "Valencia", "Newhall", "Canyon Country", "Stevenson Ranch", "Sylmar"],
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "18580 Via Princessa Suite 3",
                    "addressLocality": "Santa Clarita",
                    "addressRegion": "CA",
                    "postalCode": "91387",
                    "addressCountry": "US"
                },
                "geo": {
                    "@type": "GeoCoordinates",
                    "latitude": 34.4029618,
                    "longitude": -118.4589768
                },
                "openingHoursSpecification": [{
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday"
                    ],
                    "opens": "09:00",
                    "closes": "18:30"
                },{
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": "Friday",
                    "opens": "09:00",
                    "closes": "16:30"
                }]
                }`}
            </script>
            <script type="application/ld+json">
                {`{
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "Kidz Dental Care Pediatric Dentistry & Orthodontics",
                    "alternateName": "Kidz Dental Care",
                    "url": "https://www.kidzdentalcare661.com/",
                    "logo": "https://styles.prosites.com/litesite/8064/images/banners/banner2.jpg",
                    "sameAs": [
                        "https://www.facebook.com/kdcscv/",
                        "https://www.kidzdentalcare661.com/",
                        "https://www.instagram.com/kidzdentalcare661/"
                    ]
                    }
                `}
            </script>
        </Helmet>
    );
};

Seo.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
};
